// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.take-deep-breath-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  margin: 0 auto;
  overflow: hidden;
  background-color: #fdfdfd;
}

/* Ripple ellipse containers centered */
.ellipes-1,
.ellipes-2,
.ellipes-3 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

/* Logo or central message container */
.logo-container-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

/* Ripple Images for breathing effect */
.ellipes-1 .ripple-img {
  width: 1150px;
  animation: breathe 6s ease-in-out infinite;
}

.ellipes-2 .ripple-img {
  width: 950px;
  animation: breathe 6s ease-in-out infinite 1s;
}

.ellipes-3 .ripple-img {
  width: 750px;
  animation: breathe 6s ease-in-out infinite 2s;
}


.tagline-text{
  display: flex;
  width: 515px;
  height: 40px;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  color: #EDFCF5;
  text-align: center;
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: var(--sds-typography-subtitle-font-weight);
  line-height: 140%;
}
/* Breath animation: inhale (expand), exhale (contract) */
@keyframes breathe {
  0% {
    transform: scale(1);
    opacity: 0.6;
  }
  50% {
    transform: scale(1.3);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.6;
  }
}

/* Breathing Text Animation */
.breathing-text {
  font-size: 2rem;
  color: #333;
  animation: breathText 6s ease-in-out infinite;
  font-family: sans-serif;
}

/* Alternating text animation for inhale/exhale */
@keyframes breathText {
  0%, 45% {
    content: "Breathe In";
    opacity: 1;
  }
  50%, 95% {
    content: "Breathe Out";
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}

@media (max-width: 480px) {
  .take-deep-breath-container {
    width: 100vw;
    height: 100vh;
    padding: 0 10px;
  }

  /* Adjust ripple image sizes for small screens */
  .ellipes-1 .ripple-img {
    width: 260px;
  }

  .ellipes-2 .ripple-img {
    width: 220px;
  }

  .ellipes-3 .ripple-img {
    width: 180px;
  }

  /* Center message/logo container */
  .logo-container-loading {
    width: 100%;
    padding: 10px;
    text-align: center;
  }

  /* Tagline text styling */
  .tagline-text {
    width: 60%;
    font-size: 14px;
    padding: 0 10px;
    height: auto;
     white-space: normal;
  overflow-wrap: break-word;
  text-align: center; /* optional, for better alignment */
  margin: 0 auto;  
  }

  /* Breathing text animation size */
  .breathing-text {
    font-size: 1.2rem;
    padding: 0 10px;
  }
    .logo-container-loading img {
    width: 100px; /* or adjust as needed */
    height: auto;
    margin-bottom: 2px;
  }

  /* Optional: Reduce spacing between elements inside logo container */
  .logo-container-loading > * {
    margin-bottom: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/screens/TakeDeepBreath/TakeDeepBreath.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,uCAAuC;AACvC;;;EAGE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;AACZ;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,6CAA6C;AAC/C;;;AAGA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,uDAAuD;EACvD,iBAAiB;AACnB;AACA,yDAAyD;AACzD;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,YAAY;EACd;AACF;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,WAAW;EACX,6CAA6C;EAC7C,uBAAuB;AACzB;;AAEA,iDAAiD;AACjD;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,eAAe;EACjB;;EAEA,gDAAgD;EAChD;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA,kCAAkC;EAClC;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;EACpB;;EAEA,yBAAyB;EACzB;IACE,UAAU;IACV,eAAe;IACf,eAAe;IACf,YAAY;KACX,mBAAmB;EACtB,yBAAyB;EACzB,kBAAkB,EAAE,mCAAmC;EACvD,cAAc;EACd;;EAEA,kCAAkC;EAClC;IACE,iBAAiB;IACjB,eAAe;EACjB;IACE;IACA,YAAY,EAAE,wBAAwB;IACtC,YAAY;IACZ,kBAAkB;EACpB;;EAEA,oEAAoE;EACpE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".take-deep-breath-container {\n  position: relative;\n  width: 100vw;\n  height: 100vh;\n  margin: 0 auto;\n  overflow: hidden;\n  background-color: #fdfdfd;\n}\n\n/* Ripple ellipse containers centered */\n.ellipes-1,\n.ellipes-2,\n.ellipes-3 {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1;\n}\n\n/* Logo or central message container */\n.logo-container-loading {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n/* Ripple Images for breathing effect */\n.ellipes-1 .ripple-img {\n  width: 1150px;\n  animation: breathe 6s ease-in-out infinite;\n}\n\n.ellipes-2 .ripple-img {\n  width: 950px;\n  animation: breathe 6s ease-in-out infinite 1s;\n}\n\n.ellipes-3 .ripple-img {\n  width: 750px;\n  animation: breathe 6s ease-in-out infinite 2s;\n}\n\n\n.tagline-text{\n  display: flex;\n  width: 515px;\n  height: 40px;\n  flex-direction: column;\n  justify-content: center;\n  flex-shrink: 0;\n  color: #EDFCF5;\n  text-align: center;\n  font-family: Inter;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: var(--sds-typography-subtitle-font-weight);\n  line-height: 140%;\n}\n/* Breath animation: inhale (expand), exhale (contract) */\n@keyframes breathe {\n  0% {\n    transform: scale(1);\n    opacity: 0.6;\n  }\n  50% {\n    transform: scale(1.3);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 0.6;\n  }\n}\n\n/* Breathing Text Animation */\n.breathing-text {\n  font-size: 2rem;\n  color: #333;\n  animation: breathText 6s ease-in-out infinite;\n  font-family: sans-serif;\n}\n\n/* Alternating text animation for inhale/exhale */\n@keyframes breathText {\n  0%, 45% {\n    content: \"Breathe In\";\n    opacity: 1;\n  }\n  50%, 95% {\n    content: \"Breathe Out\";\n    opacity: 1;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@media (max-width: 480px) {\n  .take-deep-breath-container {\n    width: 100vw;\n    height: 100vh;\n    padding: 0 10px;\n  }\n\n  /* Adjust ripple image sizes for small screens */\n  .ellipes-1 .ripple-img {\n    width: 260px;\n  }\n\n  .ellipes-2 .ripple-img {\n    width: 220px;\n  }\n\n  .ellipes-3 .ripple-img {\n    width: 180px;\n  }\n\n  /* Center message/logo container */\n  .logo-container-loading {\n    width: 100%;\n    padding: 10px;\n    text-align: center;\n  }\n\n  /* Tagline text styling */\n  .tagline-text {\n    width: 60%;\n    font-size: 14px;\n    padding: 0 10px;\n    height: auto;\n     white-space: normal;\n  overflow-wrap: break-word;\n  text-align: center; /* optional, for better alignment */\n  margin: 0 auto;  \n  }\n\n  /* Breathing text animation size */\n  .breathing-text {\n    font-size: 1.2rem;\n    padding: 0 10px;\n  }\n    .logo-container-loading img {\n    width: 100px; /* or adjust as needed */\n    height: auto;\n    margin-bottom: 2px;\n  }\n\n  /* Optional: Reduce spacing between elements inside logo container */\n  .logo-container-loading > * {\n    margin-bottom: 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
